import React, { useState } from 'react';
import useAxios from 'axios-hooks';
import { Spinner } from '@fluentui/react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import SeriesTable from '../Components/SeriesTable';
import DeleteModal from "../../../../Util/DeleteModal";
import { useBoolean } from "@fluentui/react-hooks";
import ErrorComponent from '../../../../Util/ErrorComponent';
import SuccessComponent from '../../../../Util/SuccessComponent';

const DefaultPage = () => {
    const [selectedSeries, setSelectedSeries] = useState(undefined);
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: series, loading }, refetchSeries] = useAxios("resources/content/admin/series/inventory");

    if (loading) return <Spinner className="absolute-center" label="Loading Series..." />;

    return (
        <>
            <SuccessComponent
                successMessage="Series Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <SeriesTable
                series={series && series.length > 0 ? series.sort((a, b) => b.conPlaylistID - a.conPlaylistID) : []}
                setSelectedSeries={setSelectedSeries}
                selectedSeries={selectedSeries}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                deleteOnClick={(seriesItem) => {
                    setSelectedSeries(seriesItem);
                    toggleDeleteModal();
                }}
                refetch={refetchSeries}
                loading={loading}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetchSeries()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`resources/content/admin/series/delete/${selectedSeries?.conPlaylistID}/`}
                resourceName={selectedSeries?.name}
                resourceType="series"
                confirmationValue={selectedSeries?.name}
            />
        </>
    );
};

export default DefaultPage;
